global.correct = 0;